<!-- Table with manufacturer views  -->
<app-paginator
  [length]="app.manufacturersFilter.pages"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
  [type]="'manufacturer-filter'"
></app-paginator>
<app-modal
  #deleteManufacturerModal
  [modalMessage]="app.text.manufacturer.deleteModal"
  [modalTitle]="app.text.manufacturer.deleteManufacturer"
  (ok)="app.detailTable.deleteBOMItem('manufacturer')"
></app-modal>

<!-- Navigation on the manufacturers sections -->
@if (app.RM.mode === 'all-manufacturers') {
  <rm-submenu
    [sections]="['status', 'likelihood', 'rohs', 'reach', 'lead']"
  ></rm-submenu>
}

@if (app.datesFilter.showComponent) {
  <div>
    <app-dates-filter class="d-block"></app-dates-filter>
  </div>
}

<div>
  @if (app.table.selected.size > 0) {
    <button
      class="btn btn-sm btn-default-orange pull-right my-2"
      (click)="deleteManufacturerModal.open()"
      >
      <i class="fas fa-trash"></i> &nbsp;
      {{ app.text.app.delete }}
    </button>
  }
</div>
<div
  class="tableFixHead clear"
  [ngClass]="{ tableHeight: app.filterTable.isDropdownOpen }"
  >
  <table class="table table-striped spacing-table">
    <thead>
      <tr>
        @for (
          column of app.manufacturersFilter.getManufacturersColumns()
          ; track
          column) {
          <th
            class="p-1"
            [title]="app.table.setHeaderTooltip('manufacturer.' + column)"
            >
            <div class="d-inline-flex">
              <div
              [ngClass]="{
                'resize-table': app.table.canColumnBeResized(column)
              }"
                >
                @if (column === 'threadCase') {
                  <div
                    (click)="$event.stopPropagation()"
                    >
                    @if (!app.permission.RM.isAnalyst && !app.auth.isRMAdmin) {
                      <div
                        >
                        <i class="fas fa-folders"></i>
                      </div>
                    }
                  </div>
                }
                @if (column === 'partsToVehicles') {
                  <div>
                    <i class="fas fa-sitemap fa-rotate-270 pointer"></i>
                  </div>
                }
                @if (column === 'matchedSystem') {
                  <div
                    (click)="$event.stopPropagation()"
                    >
                    <i class="fas fa-database"></i>
                  </div>
                }
                @if (app.table.getColumnTypeDisplay(column) === 'link') {
                  <div>
                    {{ app.text.manufacturer.link }}
                  </div>
                }
                @if (getSortTableColumns(column)) {
                  <div
                    class="pointer"
                    (click)="sortColumn(column)"
                    [ngClass]="app.table.getSizeOfColumn(column)"
                    >
                    {{ app.field.getTableLabel("manufacturer." + column) }}
                  </div>
                }
              </div>
              &nbsp;
              @if ('manufacturer.' + column === app.table.sortField) {
                <span>
                  @if (app.table.sortDirection === 1) {
                    <i
                      class="fa fa-chevron-up"
                    ></i>
                  }
                  @if (app.table.sortDirection === -1) {
                    <i
                      class="fa fa-chevron-down"
                    ></i>
                  }
                </span>
              }
              @if (
                column === 'obsolescenceStatus' &&
                app.RMSubmenu.section === 'status'
                ) {
                <button
                  class="btn btn-sm btn-hidden p-0 ms-1"
              [title]="
                app.manufacturersFilter.forecastCollapsed
                  ? app.text.manufacturer.showForecastColumns
                  : app.text.manufacturer.hideForecastColumns
              "
              (click)="
                app.manufacturersFilter.forecastCollapsed =
                  !app.manufacturersFilter.forecastCollapsed;
                $event.stopPropagation()
              "
                  >
                  <i
                    class="fa fa-lg icon-blue"
                [ngClass]="
                  app.manufacturersFilter.forecastCollapsed
                    ? 'fa-chevron-circle-right'
                    : 'fa-chevron-circle-left'
                "
                  ></i>
                </button>
              }
            </div>
            @if (app.filterTable.getFilterTableColumns(column)) {
              <div>
                <app-filter-header-table
                  [column]="column"
                  [docType]="'manufacturer'"
                  >
                </app-filter-header-table>
              </div>
            }
          </th>
        }
        @if (app.RM.mode === 'linkedToDeletedCPN') {
          <th class="p-1">
            {{ app.text.app.delete }}
            <div>
              @if (app.table.selected.size === 0) {
                <i
                  class="far fa-square"
              (click)="
                app.table.selectAll(app.manufacturersFilter.manufacturers)
              "
                ></i>
              }
              @if (app.table.selected.size > 0) {
                <i
                  class="far fa-check-square"
                  (click)="app.table.clearSelection()"
                ></i>
              }
            </div>
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (id of app.manufacturersFilter.manufacturers; track id) {
        <tr>
          @for (
            column of app.manufacturersFilter.getManufacturersColumns()
            ; track
            column) {
            <td
              class="p-1"
              >
              <div>
                @switch (app.table.getColumnTypeDisplay(column)) {
                  @case ('textCenter') {
                    <div class="text-center">
                      {{ id[column] }}
                    </div>
                  }
                  @case ('navigateAction') {
                    <div>
                      @if (column === 'partNumber') {
                        <span
                          (click)="app.part.navigateToPartDetails(id[column])"
                          class="partNumber"
                          >
                          {{ id[column] }}
                        </span>
                      }
                      @if (
                        column === 'manufacturerPartNumber' ||
                        column === 'manufacturerPartNumberRaw'
                        ) {
                        <span
                          (click)="app.manufacturer.navigateToManufacturerDetails(id._id)"
                          class="partNumber"
                          >
                          {{ id[column] }}
                        </span>
                      }
                    </div>
                  }
                  @case ('partsToVehicles') {
                    <div
                      >
                      <i
                        class="fas fa-sitemap fa-rotate-270 pointer icon-blue p-1"
                (click)="
                  selectedWhereUsedPartNumber = id.partNumber;
                  seeWhereUsedTreeModal.open();
                  $event.stopPropagation()
                "
                        [title]="app.text.part.whereUsed"
                      ></i>
                    </div>
                  }
                  @case ('radio') {
                    <div>
                      @if (column === 'partObsolescenceManagement') {
                        <span>
                          @if (app.field.isTrue(id[column])) {
                            <i class="far fa-dot-circle"></i>
                          }
                          @if (app.field.isFalse(id[column])) {
                            <i class="fal fa-circle"></i>
                          }
                        </span>
                      }
                      @if (column !== 'partObsolescenceManagement') {
                        <span>
                          @if (app.field.isTrue(id[column])) {
                            <i
                              class="fas fa-star-of-life"
                            ></i>
                          }
                        </span>
                      }
                    </div>
                  }
                  @case ('pending') {
                    <div>
                      @if (id[column] === true) {
                        <span>
                          {{ app.text.manufacturer.pending }}
                        </span>
                      }
                    </div>
                  }
                  @case ('actions') {
                    <div>
                      @if (app.permission.RM.createCase) {
                        <span>
                          @if (
                            !app.thread.getCase(id) && id.manufacturerPartNumber !== ''
                            ) {
                            <i
                              class="far fa-folder-plus icon-blue pointer p-1"
                  (click)="
                    app.manufacturersFilter.currentManufacturer = id;
                    app.thread.newCase(id)
                  "
                            ></i>
                          }
                          @if (app.thread.getCase(id)) {
                            <i
                              class="fas fa-folder-open icon-blue pointer p-1"
                  (click)="
                    seeOpenedCasesModal.open();
                    app.manufacturersFilter.currentManufacturer = id;
                    app.thread.getCasesByPartNumber(id)
                  "
                            ></i>
                          }
                        </span>
                      }
                    </div>
                  }
                  @case ('filterType') {
                    <div>
                      <a (click)="app.treeRow.navigateToMatchingPage(null, id)">
                        @if (
                          app.manufacturer.getMatchingStatusOfManufacturer(id) ===
                          'matched'
                          ) {
                          <i
                            class="far fa-link icon-blue pointer p-1"
                          ></i>
                        }
                        @if (
                          app.manufacturer.getMatchingStatusOfManufacturer(id) ===
                          'manual'
                          ) {
                          <i
                            class="fa fa-user-circle icon-blue pointer p-1"
                          ></i>
                        }
                        @if (
                          app.manufacturer.getMatchingStatusOfManufacturer(id) ===
                          'unmatched'
                          ) {
                          <i
                            class="far fa-unlink icon-blue pointer p-1"
                          ></i>
                        }
                        @if (
                          app.manufacturer.getMatchingStatusOfManufacturer(id) ===
                          'override'
                          ) {
                          <i
                            class="far fa-hand-paper icon-blue pointer"
                          ></i>
                        }
                        @if (
                          app.manufacturer.getMatchingStatusOfManufacturer(id) ===
                          'manualAssignment'
                          ) {
                          <i
                            class="fas fa-user-edit icon-blue p-1 pointer"
                          ></i>
                        }
                      </a>
                    </div>
                  }
                  @case ('badge') {
                    <div>
                      @if (id[column] !== 'withoutData') {
                        <span
                          class="badge text-center manufacturer-filter-badge"
                [ngClass]="{
                  'status-column-badge':
                    column === 'obsolescenceStatus' ||
                    column === 'obsolescenceStatus2years' ||
                    column === 'obsolescenceStatus4years' ||
                    column === 'obsolescenceStatus6years' ||
                    column === 'obsolescenceStatus8years',
                  'manufacturer-filter-non-status-badge':
                    column !== 'obsolescenceStatus' &&
                    column !== 'obsolescenceStatus2years' &&
                    column !== 'obsolescenceStatus4years' &&
                    column !== 'obsolescenceStatus6years' &&
                    column !== 'obsolescenceStatus8years'
                }"
                [ngStyle]="
                  app.field.getColor('manufacturer.' + column, id[column])
                "
                          >
                          {{
                          app.field.getOptionText("manufacturer." + column, id[column])
                          }}
                        </span>
                      }
                    </div>
                  }
                  @case ('link') {
                    <div>
                      @if (id[column]) {
                        <a [href]="id[column]" target="_blank">
                          <i class="fas fa-file icon-blue"></i>
                        </a>
                      }
                    </div>
                  }
                  @case ('decimalNumber') {
                    <div class="smallCell">
                      @if (id[column] > -1) {
                        <span>
                          {{ app.field.formatNumberWithDecimals(id[column], 2) }}
                        </span>
                      }
                    </div>
                  }
                  @case ('date') {
                    <div>
                      @if (id[column] > 0) {
                        <span>
                          {{ id[column] | date: "yyyy-MM-dd" : "UTC" }}
                        </span>
                      }
                    </div>
                  }
                  @case ('optionText') {
                    <div>
                      {{
                      app.field.getFieldValueAsText(
                      "manufacturer." + column,
                      id[column]
                      )
                      }}
                    </div>
                  }
                  @default {
                    <div>
                      {{ id[column] }}
                    </div>
                  }
                }
              </div>
            </td>
          }
          @if (app.RM.mode === 'linkedToDeletedCPN') {
            <td class="p-1">
              <button
                class="btn btn-hidden pt-0 ps-0"
                (click)="app.table.toggleSelect(id); $event.stopPropagation()"
                >
                @if (app.table.selected.has(id)) {
                  <i
                    class="far fa-check-square"
                  ></i>
                }
                @if (!app.table.selected.has(id)) {
                  <i class="far fa-square"></i>
                }
              </button>
            </td>
          }
        </tr>
      }
      <tr>
        @if (loading) {
          <td colspan="99" class="text-center">
            {{ this.app.text.core.loading }}
          </td>
        }
        @if (!loading && app.manufacturersFilter.manufacturers.length === 0) {
          <td
            colspan="99"
            class="text-center"
            >
            {{ this.app.text.core.noResults }}
          </td>
        }
      </tr>
    </tbody>
  </table>
</div>
<app-paginator
  [length]="app.manufacturersFilter.pages"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
  [type]="'manufacturer-filter'"
></app-paginator>

<app-modal
  #seeWhereUsedTreeModal
  [modalTitle]="app.text.part.whereUsed"
  [showButtons]="false"
  [modalType]="'showWhereUsedTree'"
  [whereUsedCustomer]="app.customers.expectCurrent"
  [whereUsedPartNumber]="selectedWhereUsedPartNumber"
  >
</app-modal>
<app-modal
  #seeOpenedCasesModal
  [modalTitle]="app.text.thread.threads"
  [modalType]="'showListOfCases'"
  [showButtons]="false"
  >
</app-modal>
